import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SNItem } from 'src/app/models/snitem';
import { Printer, PrintService } from 'src/app/services/print.service';

@Component({
  selector: 'app-print-item-dialog',
  templateUrl: './print-item-dialog.component.html',
  styleUrls: ['./print-item-dialog.component.scss']
})
export class PrintItemDialogComponent implements OnInit {

  private itemToPrint: SNItem;
  private selectedPrinter: Printer;

  constructor(private dialogRef: MatDialogRef<PrintItemDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              private printSrv: PrintService) {
    this.itemToPrint = data;
  }

  ngOnInit(): void {
  }

  selectPrinter(printer: Printer): void {
    this.selectedPrinter = printer;
  }

  print(): void {
    this.printSrv.printItem(this.itemToPrint, this.selectedPrinter).subscribe(result => {
      this.dialogRef.close();
    });
  }

  pdf(): void {
    const pdfPrinter = new Printer();
    pdfPrinter.id = 'pdf';
    pdfPrinter.name = 'pdf';
    this.printSrv.printItem(this.itemToPrint, pdfPrinter).subscribe(result => {
      // open document in other tab
      const documentLink = '/SN/StVaast/DocumentFile.php?doc=' + result;
      window.open(documentLink, '_blank');
      this.dialogRef.close();
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
